export default{
    title:'HiRiders',
    smallTitle:'Intelligent Cycling APP',
    describe:'Embark On Your New Cycling Adventure',
    content:'Smart, Portable, And Fun, Redefining Every Ride',
    iosDownload:'App Store Download',
    AndroidDownload:'Android Download',
    twoTitle:'HiRiders Advantage',
    twoDescribe:'Bluetooth Unlock',
    twoDescribeTwo:'Intelligent Route Planning',
    twoDescribeThree:'Health Data Shows',
    twoDescribeFour:'Social Interaction',
    threeTitle:'HiRiders Is Born For Sports',
    threeDescribe:'Three Simple Steps, Bind Your Car, And Enjoy The Fun Of Riding',
    fourTitle:'Embark On A New Cycling Experience',
    fourDescribe:'Three Simple Steps, Bind Your Car, And Enjoy The Fun Of Riding',
    fourContentFirstTitle:'Download APP',
    fourContentFirstContent:'HiRiders APP，Your Accompanying Butler,',
    fourContentFirstContentTwo:'Unlock A New Riding Experience With One Click',
    fourContentSecondTitle:'Bind Pairing',
    fourContentSecondContent:'With Just A Few Simple Steps, You Can Bind The Smart',
    fourContentSecondContentTwo:'Ashboard That Comes With Your Vehicle In The App,',
    fourContentSecondContentThree:'And Then You Can Keep Your Beloved Car Under Control',
    fourContentThirdTitle:'Start Smart Cycling',
    fourContentThirdContent:'Remotely View Vehicle Status (Battery Condition,',
    fourContentThirdContentTwo:'Parking Location, Etc.), Remotely Unlock And Lock,',
    fourContentThirdContentThree:'Indulge In A Smart And Portable Cycling Lifestyle',
    footTitle:'Embark On Your New Cycling Experience',
    footCompanyName:'Shenzhen Jlink Times Technology Co.,Ltd',
    footRecordNumber:'Guangdong ICP No. 18045622'
}